import React, { useCallback, useMemo, useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Button,
  Dialog,
  Tooltip,
  TextField,
  Box,
} from "@material-ui/core";
import Draggable from "react-draggable";
import DataTable from "react-data-table-component";
import { useStyles, paperPropsBig } from "../../../css/muiStyle";
import { customStyles, numberColumn } from "../../../css/datatableStyle";
import Iconn from "@mdi/react";
import { mdiCashRegister, mdiSwapHorizontalBold } from "@mdi/js";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Add, IndeterminateCheckBox, Search } from "@material-ui/icons";
import { AlertCompo, AutocompleteS } from "../../../js/components";
import { Autocomplete } from "@material-ui/lab";
import ContentEditable from "react-contenteditable";

//add new marque
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const Ref_bdl_switch = React.memo((props) => {
  const Gfunc = require("../../../Gfunc");
  const param = props.param;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [control, setControl] = useState(false);
  const [bdlL, setBdlL] = useState([]);
  const [bdl, setBdl] = useState("");
  const [bdlN, setBdlN] = useState("");
  const [bdl2, setBdl2] = useState("");
  const [bdlN2, setBdlN2] = useState("");
  const [data, setData] = useState([]);
  const librery = require("../../../js/data_table_librery");
  const [keyword, setKeyword] = useState("");
  const addTitle = "Switch bundles";
  const service = "_bdl.php";
  const classes = useStyles();
  const labelText3 = "Remplaçant";
  const labelText2 = "Mot clé";
  const labelText1 = "Bundle";
  const [severity, setSeverity] = useState("info");
  const [openA, setOpenA] = useState(false);
  const [messageA, setMessageA] = useState("");
  const [search, setSearch] = useState("");
  const [, setDel] = useState("");

  //handle alerts properties
  const handleAlert = (open, severity, message) => {
    setOpenA(open);
    setSeverity(severity);
    setMessageA(message);
    setTimeout(function () {
      setOpenA(false);
    }, 5000);
  };

  const fetch = async () => {
    setLoading(true);
    const response = await Gfunc.axiosGetAction("_bdl.php", "getbsw");
    if (response.data.err && response.data.err !== "-1") {
      alert(response.data.err);
      setOpen(false);
    } else
      Gfunc.axiosResponse(response, () => {
        if (response.data.jData !== undefined) {
          setData(response.data.jData ?? []);
        }
      });
    setLoading(false);
  };

  const handleClickOpen = () => {
    setKeyword("");
    fetch();
    fetchBdl();
    setBdl("");
    setBdlN("");
    setBdl2("");
    setBdlN2("");
    setData([]);
    setOpen(true);
  };

  const handleSubmit = async () => {
    const dat = {
      origineId: bdl,
      targetId: bdl2,
      keyword: keyword,
    };
    const respon = await Gfunc.axiosPostAction("_bdl.php", "addbsw", dat);
    if (respon.data.err && respon.data.err !== "-1") {
      handleAlert(true, "error", respon.data.err);
    } else
      Gfunc.axiosResponse(respon, () => {
        //props.getConso();
        // data.unshift({date:Gfunc.getDate(),caissier:localStorage.getItem("name"),keyword:keyword,mtn:mtn,conso:respon.data.jData});
        //setOpen(false);
        fetch();
        fetchBdl();
        setBdl("");
        setBdlN("");
        setBdl2("");
        setBdlN2("");
        setKeyword("");
        const elem = document.getElementById("iBdl");
        if (elem) elem.focus();
        setControl(!control);
      });
  };

  //delete
  const handleSetData = useCallback(
    (row, att) => {
      Gfunc.removeItemsByAtt(data, row.DT_RowId, att);
      setDel("");
    },
    [data, Gfunc]
  );

  //handle delete
  const handleDelete = useCallback(
    async (row) => {
      const x = window.confirm("Êtes-vous sure de supprimer cet élément?");
      if (x) {
        const response = await Gfunc.axiosPostAction("_bdl.php", "delbsw", {
          switchId: row.switchId,
        });
        if (response.data.err && response.data.err !== "-1") {
          handleAlert(true, "error", response.data.err);
        } else {
          Gfunc.axiosResponse(response, () => {
            handleAlert(true, "success", "L'élément est supprimé avec succès.");
            handleSetData(row, "DT_RowId");
            setDel(row.switchId);
            setControl(!control);
          });
        }
      }
    },
    [Gfunc, handleSetData, handleAlert]
  );

  //fetch users
  const fetchBdl = useCallback(
    async (serv = "_bdl.php", act = "gets") => {
      const response = await Gfunc.axiosGetAction(serv, act);
      if (response.data.err) {
        handleAlert(true, "error", response.data.err);
      } else {
        Gfunc.axiosResponse(response, () => {
          setBdlL(response.data.jData);
        });
      }
    },
    [Gfunc]
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnEdit = useCallback(
    async (e, row, att, action, id) => {
      const edt1 = e.target.innerHTML;
      const edt = Gfunc.DeleteSpace(edt1);

      if (row[att] !== edt) {
        const attrib = row[att];
        const response = await librery.axiosEdit2(
          service,
          action,
          row,
          edt,
          att,
          id,
          "text"
        );
        if (response.data.err && response.data.err !== "-1") {
          handleAlert(true, "error", response.data.err);
        } else {
          Gfunc.axiosResponse(response, () => {
            row[att] = edt;
            e.target.innerHTML = edt;
          });
        }
        if (response.data.err) {
          e.target.innerHTML = attrib;
        }
      } else {
        e.target.innerHTML = edt;
      }
    },
    [librery, Gfunc]
  );

  const columns = useMemo(
    () => [
      {
        name: labelText1,
        minWidth: "135px !important",
        selector: (row) => row.origine,
        sortable: true,
        cell: (row) => (
          <AutocompleteS
            service={service}
            action={"updbsw"}
            defaultValue={bdlL.filter((e) => e.id !== row.targetId)}
            row={row}
            list={bdlL}
            id={"origineId"}
            name="origine"
            attr="name"
            rowId="switchId"
            handleAlert={handleAlert}
          />
        ),
      },
      {
        name: labelText2,
        width: "135px !important",
        selector: (row) => row.date,
        sortable: true,
        cell: (row) => (
          <ContentEditable
            html={row.bundle !== null ? row.keyword : ""}
            name="keyword"
            data-column="item"
            className="content-editable"
            disabled={false}
            onBlur={(e) =>
              handleOnEdit(e, row, "keyword", "updbsw", "switchId")
            }
          />
        ),
      },
      {
        name: labelText3,
        minWidth: "135px !important",
        selector: (row) => row.target,

        sortable: true,
        cell: (row) => (
          <AutocompleteS
            service={service}
            action={"updbsw"}
            defaultValue={row.target}
            row={row}
            list={bdlL.filter((e) => e.id !== row.origineId)}
            id={"targetId"}
            name="target"
            attr="name"
            rowId="switchId"
            handleAlert={handleAlert}
          />
        ),
      },
      {
        name: "Agent",
        minWidth: "135px !important",
        selector: (row) => row.agent,
        sortable: true,
      },
      {
        name: "Date",
        minWidth: "135px !important",
        selector: (row) => row.date,
        sortable: true,
      },
      {
        right: true,
        maxWidth: "30px !important",
        cell: (row, index) => {
          return (
            <div className="rowGrid" id="oneIcons" title="Supprimer">
              <IndeterminateCheckBox
                fontSize="small"
                onClick={() => handleDelete(row, index)}
                className={classes.redIcon}
              />{" "}
            </div>
          );
        },
      },
    ],
    [handleDelete]
  );

  //recherche serverside
  const handleSearch = async () => {
    // const results = searchData([...data], search);
    // setData(results);
  };

  function liveSearch(e, search) {
    if (param.liveSearch && search.length > 3) {
      e.preventDefault();
      handleSearch();
    } else {
      if (e.keyCode === 13) {
        e.preventDefault();
        handleSearch();
      }
    }
  }

  function liveSearch2() {
    handleSearch();
  }
  return (
    <div>
      <Button
        className={classes.topTabBtn}
        variant="contained"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={
          <Iconn path={mdiSwapHorizontalBold} size={0.7} color={"black"} />
        }
      >
        Switch bundles
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={paperPropsBig}
      >
        <DialogTitle
          className={classes.topDivTitle}
          id="draggable-dialog-title"
        >
          {addTitle}
        </DialogTitle>
        <AlertCompo
          severity={severity}
          open={openA}
          setOpen={setOpenA}
          message={messageA}
          dialg={true}
        />
        <DialogContent>
          <fieldset className="fieldsetTop2" id="switchBdl">
            <legend>Switcher des bundles</legend>
            <ValidatorForm
              id="switchForm"
              onSubmit={handleSubmit}
              onError={(errors) => console.log(errors)}
            >
              <Autocomplete
                disableClearable
                className="smallAuto"
                id="iBdl"
                onChange={(e, newValue) => {
                  //const idf=props.bdlL[Gfunc.getIndex(props.bdlL,newValue,"name")].id
                  setBdl(newValue.id);
                  setBdlN(newValue.name);
                  //fetch(newValue.id);
                }}
                value={{ id: parseInt(bdl), name: bdlN }}
                options={bdlL.filter((e) => e.id !== bdl2)}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={labelText1}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    required
                  />
                )}
              />

              <TextValidator
                size="small"
                variant="outlined"
                label={labelText2}
                id="iMot"
                name="iMot"
                value={keyword}
                margin="dense"
                className="smallText"
                onChange={(e) => setKeyword(e.target.value)}
              />
              <Autocomplete
                disableClearable
                className="smallAuto"
                id="iBdl2"
                onChange={(e, newValue) => {
                  setBdl2(newValue.id);
                  setBdlN2(newValue.name);
                }}
                value={{ id: parseInt(bdl2), name: bdlN2 }}
                options={bdlL.filter((e) => e.id !== bdl)}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={labelText3}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    required
                  />
                )}
              />
              <Button
                className={classes.diagTabBtn}
                type="submit"
                variant="contained"
                color="primary"
                startIcon={
                  <Iconn
                    path={mdiSwapHorizontalBold}
                    size={0.7}
                    color={"white"}
                  />
                }
              >
                APPLIQUER
              </Button>
            </ValidatorForm>
          </fieldset>
          <div className="table-header">
            <div className="button-flex-wrapper"></div>
            <div className="search">
              <Box
                sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}
              >
                <Search
                  className={classes.blackIcon}
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                  onClick={(e) => liveSearch2(e)}
                />
                <TextField
                  className="smallText"
                  id="searchBar"
                  variant="outlined"
                  label="Recherche"
                  value={search}
                  size="small"
                  margin="dense"
                  onKeyUp={(e) => liveSearch(e)}
                  onChange={(e) => setSearch(e.target.value)}
                  autoFocus
                />
              </Box>
            </div>
          </div>
          <DataTable
            key={control}
            columns={columns}
            data={Gfunc.searchData([...data], search)}
            pagination
            paginationPerPage={20}
            noDataComponent={param.ErreurData}
            progressPending={loading}
            highlightOnHover
            noHeader={true}
            customStyles={customStyles}
            paginationComponentOptions={{
              rowsPerPageText: "Élément par page:",
              rangeSeparatorText: "sur",
              selectAllRowsItem: true,
              selectAllRowsItemText: "Tous",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="secondary">
            FERMER
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
export default Ref_bdl_switch;
